module.exports = __webpack_public_path__ + "static/img/shangbiao_12.ed71ae2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shangbiao_12.png
// module id = DH5i
// module chunks = 0